// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"489":"354dd129","636":"8de21a03","799":"0c9303a3","921":"678132d7"}[chunkId] + ".chunk.js";
};